<ng-container *ngIf="formGroup">
    <div [formGroup]="formGroup" class="container-question-types">
        <ng-container [ngSwitch]="question.typeConfig.type">
            <ng-container *ngSwitchCase="QuestionType.Boolean">
                <app-boolean-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [isManagerComment]="isManagerComment"
                        [showRequiredBadge]="showRequiredBadge.bind(this)">
                </app-boolean-questions>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.Calculate">
                <ng-container *ngIf="!questionsType[QuestionType.Calculate].hidden">
                    <app-calculate-questions
                            [question]="question"
                            [formGroup]="formGroup">
                    </app-calculate-questions>
                </ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.Date">
                <app-date-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [isManagerComment]="isManagerComment">
                </app-date-questions>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.GroupedSlider">
                <app-grouped-slider-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [evaluation]="evaluation"
                        [managerAnswer]="managerAnswer"
                        [isManagerComment]="isManagerComment"
                        [descriptionTooltip]="descriptionTooltip"
                        [hideQuestionTitle]="hideQuestionTitle"
                        [setTooltip]="setTooltip.bind(this)"
                        [openDescriptionConcept]="openDescriptionConcept.bind(this)"
                        [showRequiredBadge]="showRequiredBadge.bind(this)"
                        [getQuestionAnswer]="getQuestionAnswer.bind(this)"
                        [setRangeValue]="setRangeValue.bind(this)"
                        [cycleId] = "cycleId"
                        [subordinatedId] = "subordinatedId">
                </app-grouped-slider-questions>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.MultiSelection">
                <app-multi-selection-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [isManagerComment]="isManagerComment"
                        [descriptionTooltip]="descriptionTooltip"
                        [setTooltip]="setTooltip.bind(this)"
                        [openDescriptionConcept]="openDescriptionConcept.bind(this)"
                        [showRequiredBadge]="showRequiredBadge.bind(this)">
                </app-multi-selection-questions>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.Number">
                <app-number-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [isManagerComment]="isManagerComment">
                </app-number-questions>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.Selection">
                <app-selection-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [isManagerComment]="isManagerComment">
                </app-selection-questions>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.Slider">
                <app-slider-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [descriptionTooltip]="descriptionTooltip"
                        [hideQuestionTitle]="hideQuestionTitle"
                        [isManagerComment]="isManagerComment"
                        [evaluation]="evaluation"
                        [managerAnswer]="managerAnswer"
                        [setTooltip]="setTooltip.bind(this)"
                        [openDescriptionConcept]="openDescriptionConcept.bind(this)"
                        [showRequiredBadge]="showRequiredBadge.bind(this)"
                        [getQuestionAnswer]="getQuestionAnswer.bind(this)"
                        [setRangeValue]="setRangeValue.bind(this)">
                </app-slider-questions>
            </ng-container>

            <ng-container *ngSwitchCase="QuestionType.Text">
                <app-text-questions
                        [question]="question"
                        [formGroup]="formGroup"
                        [isManagerComment]="isManagerComment"
                        [evaluation]="evaluation"
                        [managerAnswer]="managerAnswer"
                        [showRequiredBadge]="showRequiredBadge.bind(this)"
                        [getQuestionAnswer]="getQuestionAnswer.bind(this)"
                        [isFinalFeedbackReview]="isFinalFeedbackReview"
                        [disableEdition]="disableEdition">
                </app-text-questions>
            </ng-container>
        </ng-container>
    </div>
</ng-container>